import { render, staticRenderFns } from "./GetMessagesStatisticsGateways.vue?vue&type=template&id=7b21744b&"
import script from "./GetMessagesStatisticsGateways.vue?vue&type=script&lang=js&"
export * from "./GetMessagesStatisticsGateways.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports